import React, { useState } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import AutoCompleteInput from 'components/Common/Inputs/AutoCompleteInput';

const SearchPanel = ({ searchCriteria, onSearchCriteriaChanged, onSearchClicked }) => {
  const [raisedWithin, SetRaisedWithin] = useState(90);

  const onSearchClick = () => {
    onSearchClicked(searchCriteria);
  };

  const onAutoCompleteChange = (_, lookupValue, propertyName) => {
    const newSearchCriteria = Object.assign({}, searchCriteria);

    if ((typeof lookupValue === 'string' || lookupValue instanceof String)) {
      newSearchCriteria[propertyName] = lookupValue;
      newSearchCriteria[`${ propertyName }Selected`] = false;
    } else if (lookupValue !== null) {
      newSearchCriteria[propertyName] = lookupValue;
      newSearchCriteria[`${ propertyName }Selected`] = true;
    }
    onSearchCriteriaChanged(newSearchCriteria);
  };

  const onCountChange = (e) => {
    const newSearchCriteria = Object.assign({}, searchCriteria);

    newSearchCriteria.raisedWithin = e.target.value;
    SetRaisedWithin(e.target.value);
    onSearchCriteriaChanged(newSearchCriteria);
  };

  return (
    <div className="panel search-panel">
      <div className="panel-body">
        <div className="row search-row">
          <div className="col-2 p-2">
            <AutoCompleteInput
              className="form-input"
              id="customer-id"
              name="customerId"
              category="customer"
              placeholder="Shareholder ID"
              value={ searchCriteria.customer || '' }
              activeOnly={ false }
              onChange={ (_, value) => onAutoCompleteChange(null, value, 'customer') }
              onSelectedItem={ value => onAutoCompleteChange(null, value, 'customer') }
            />
          </div>
          <div className="col-2 p-2">
            <AutoCompleteInput
              className="form-input"
              id="account-number"
              name="accountNumber"
              category="account"
              placeholder="Account Number"
              value={ searchCriteria.accountNumber || '' }
              activeOnly={ false }
              onChange={ (_, value) => onAutoCompleteChange(null, value, 'accountNumber') }
              onSelectedItem={ value => onAutoCompleteChange(null, value, 'accountNumber') }
            />
          </div>
          <div className="col-2 p-2">
            <AutoCompleteInput
              className="form-input"
              id="legal-entity-id"
              name="legalEntity"
              category="legalentity"
              placeholder="Legal Entity Name"
              value={ searchCriteria.legalEntity || '' }
              activeOnly={ false }
              onChange={ (_, value) => onAutoCompleteChange(null, value, 'legalEntity') }
              onSelectedItem={ value => onAutoCompleteChange(null, value, 'legalEntity') }
            />
          </div>
          <div className="col-2 p-2">
            <select
              className="form-select"
              value={ raisedWithin }
              onChange={ e => onCountChange(e) }
            >
              <option value="">Any Time Period</option>
              <option value="90">Last 90 days</option>
              <option value="60">Last 60 days</option>
              <option value="30">Last 30 days</option>
            </select>
          </div>
          <div className="col p-2">
            <button
              id="search-btn"
              type="button"
              className="btn btn-primary search-btn"
              onClick={ () => onSearchClick() }
            ><span className="icon icon-search" /> Search</button>
          </div>
        </div>
      </div>
    </div>
  );
};

SearchPanel.propTypes = {
  searchCriteria: PropTypes.shape().isRequired,
  onSearchCriteriaChanged: PropTypes.func.isRequired,
  onSearchClicked: PropTypes.func.isRequired
};

const SearchPanelForm = reduxForm({
  form: 'monitoringSearchForm',
})(SearchPanel);

const mapDispatchToProps = dispatch => ({ dispatch });

const ConnectedMonitoringSearchPanel = connect(
  // ({ monitoring }) => ({
  //   cicAlertsList: monitoring.cicAlertsList,
  //   cicAlertsListCount: monitoring.cicAlertsListCount
  // }),
  mapDispatchToProps
)(SearchPanelForm);

export default ConnectedMonitoringSearchPanel;
